
import React, { forwardRef } from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onClear: () => void;
  placeholder: string;
  isMobile: boolean;
  isFocused: boolean;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ value, onChange, onFocus, onClear, placeholder, isMobile, isFocused }, ref) => {
    // More compact styling with reduced height and added shadow effect
    const styles = isMobile ? {
      searchBox: "relative flex items-center rounded-3xl bg-white border border-gray-200",
      inputFocused: "ring-1 ring-gray-300",
      input: "pl-10 pr-10 py-2 h-10 w-full rounded-2xl text-sm border-0 focus-visible:ring-0 focus-visible:ring-offset-0 bg-transparent",
    } : {
      searchBox: "relative flex items-center rounded-2xl border border-gray-200 bg-white py-1 shadow-[0_4px_20px_rgba(0,0,0,0.15)]",
      inputFocused: "ring-1 ring-gray-400 shadow-[0_6px_25px_rgba(0,0,0,0.2)]",
      input: "pl-9 pr-9 py-1.5 h-10 w-full rounded-full text-sm border-0 focus-visible:ring-0 focus-visible:ring-offset-0",
    };

    return (
      <div className={`${styles.searchBox} transition-all duration-200 ${isFocused ? styles.inputFocused : ''}`}>
        <div className={`absolute ${isMobile ? 'left-4' : 'left-3'} text-gray-400`}>
          <Search size={isMobile ? 18 : 16} />
        </div>
        <Input
          ref={ref}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          className={styles.input}
        />
        {value && (
          <button 
            type="button"
            className={`absolute ${isMobile ? 'right-4' : 'right-3'} text-gray-400 hover:text-gray-600`}
            onClick={onClear}
          >
            <X size={isMobile ? 16 : 14} />
          </button>
        )}
      </div>
    );
  }
);

SearchInput.displayName = 'SearchInput';

export default SearchInput;
